export default __webpack_public_path__ + "cf-redeem-locales/en-US.eeb6aa1cae114b6e9d3a61ce57458327.json";